<div class="chart-container" *ngIf="data && data.length > 0 && !isPieChartLoder">
    <p class="chart-title" *ngIf="!isMaterialChart">Documents Categories</p>
    <div [ngStyle]="{'width': chatWidth, 'display': 'block'}">
        <canvas [id]="chartId">{{ chart }}</canvas>
    </div>
</div>

<div class="loader-container" *ngIf="isPieChartLoder">
    <app-common-icon [loadingIcon]="true" class="text-danger"></app-common-icon>
</div>

<div class="color-red error-message" *ngIf="(!data || data.length === 0) && !isPieChartLoder && showErrorMessage">
    <p>There are currently No files/documents</p>
</div>